import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import api from "@/lib/api";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/testimonials").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  return (
    <section className="relative section-pad overflow-hidden" data-testid="testimonials-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 mb-14">
          <div className="col-span-12 md:col-span-7">
            <div className="overline mb-4">07 · Testimonials</div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-[-0.02em] leading-[1]">
              What partners <span className="italic text-gradient">actually say</span>.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {items.map((t, i) => (
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
              className="card-surface p-8 lg:p-10 relative"
              data-testid={`testimonial-${i}`}
            >
              <div className="flex items-center gap-1 mb-4 text-brand-primary">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <Star key={j} size={13} fill="currentColor" />
                ))}
              </div>
              <p className="font-serif text-2xl md:text-[26px] leading-snug tracking-tight">
                "{t.quote}"
              </p>
              <div className="mt-8 flex items-center justify-between">
                <div>
                  <div className="font-semibold">{t.name}</div>
                  <div className="text-[13px] text-[color:var(--text-muted)]">{t.role}, {t.company}</div>
                </div>
                <div className="font-mono text-[11px] tracking-widest text-[color:var(--text-muted)]">
                  0{i + 1}/0{items.length || 4}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
